import http from "./httpService";

const baseUrl = `/admins`;

export const createAdmin = async (memberData, password) => {
  try {
    const {
      data: { message },
      status,
    } = await http.post(baseUrl, {
      ...memberData,
      password,
    });

    return { status, message };
  } catch (err) {
    return {};
  }
};

export const updateAdmin = async (id, updateData) => {
  try {
    const {
      data: { message },
      status,
    } = await http.put(`${baseUrl}/${id}`, updateData);

    return { status, message };
  } catch (err) {
    return {};
  }
};

export const getAdmins = async () => {
  try {
    const { data } = await http.get(baseUrl);
    return data.admins || [];
  } catch (err) {
    return [];
  }
};

export const inviteAdmin = async ({ email, role, scope }) => {
  try {
    const { status, data } = await http.post(`${baseUrl}/invite`, { email, role, scope });
    return { status, admin: data.admin, message: data.message };
  } catch (err) {
    return { status: err?.response?.status, message: err?.response?.data?.message };
  }
};

export const deleteAdmin = async (id) => {
  try {
    const { status } = await http.delete(`${baseUrl}/${id}`);
    return { status };
  } catch (err) {
    return {};
  }
};
